import React from 'react';
import imgPetitBateau from './images/boutons/petit-bateau.png';
import imgMerou from './images/boutons/merou.png';
import imgInvertebres from './images/boutons/invertebres.png';
import imgPoissons from './images/boutons/poissons.png';
import imgPoissonHerbiers from './images/boutons/poisson-herbiers.png';
import imgCorb from './images/boutons/corb.png';
import imgDauphin from './images/boutons/dauphin.png';
import imgRorqual from './images/boutons/rorqual.png';
import imgCachalot from './images/boutons/cachalot.png';
// import imgGrosBateau from './images/boutons/gros-bateau.png';
// import imgJetSki from './images/boutons/jet-ski.png';

/* const commentairé = [
	{
		id: 2,
		name: "Gros bateau",
		x: 20,
		y: 67,
		img: imgGrosBateau,
		texte: <></>,
		plusLoin: "",
		son: "13_navire_gros_40s.wav",
	},
	{
		id: 9,
		name: "Jet-ski",
		x: 69,
		y: 27,
		img: imgJetSki,
		texte: <></>,
		plusLoin: "",
		son: "13_jet_ski.wav",
	},
] */

export const dataSeaSounds = [
	{
		id: 1,
		name: "Mérou",
		x: 25,
		y: 78,
		img: imgMerou,
		portee: 100,
		texte: <>
			<p>Range of about 100 m</p>
			<p>Emission as part of reproduction in summer at night</p>
		</>,	
		plusLoin: <>
			<p>Bertucci, F., Lejeune, P., Payrot, J., & Parmentier, E. (2015). Sound production by dusky grouper Epinephelus marginatus at spawning aggregation sites. Journal of Fish Biology, 87(2), 400-421.</p>
			<p>Desiderà, E., Mazzoldi, C., Navone, A., Panzalis, P., Gervaise, C., Guidetti, P., & Iorio, L. D. (2022). Reproductive Behaviours and Potentially Associated Sounds of the Mottled Grouper Mycteroperca rubra: Implications for Conservation. Diversity, 14(5), 318.</p>
		</>,
		son: "03_merou.wav",
	},
	{
		id: 2,
		name: "Small boat",
		x: 21,
		y: 55,
		img: imgPetitBateau,
		portee: 2000,
		texte: <>
			<p>Range of approximately 2000 m for small craft for coastal environments</p>
			<p>4 components:<br/>Propeller cavitation, machinery noise, bow wave, hydrodynamic noise</p>
		</>,
		plusLoin: <>
			<p>Gervaise, C., Simard, Y., Roy, N., Kinda, B., & Menard, N. (2012). Shipping noise in whale habitat: Characteristics, sources, budget, and impact on belugas in Saguenay–St. Lawrence Marine Park hub. The Journal of the Acoustical Society of America, 132(1), 76-89.</p>
			<p>Simard, Y., Roy, N., Gervaise, C., & Giard, S. (2016). Analysis and modeling of 255 source levels of merchant ships from an acoustic observatory along St. Lawrence Seaway. The Journal of the Acoustical Society of America, 140(3), 2002-2018.</p>
			<p>Magnier, C., & Gervaise, C. (2020). Acoustic and photographic monitoring of coastal maritime traffic: Influence on the soundscape. The Journal of the Acoustical Society of America, 147(6), 3749-3757.</p>
		</>,
		son: "13_navire_petit_60s.wav",
	},
	{
		id: 3,
		name: "Invertebrates",
		x: 29,
		y: 28,
		img: imgInvertebres,
		portee: 1000,
		texte: <>
			<p>Benthic invertebrates are not very mobile and emit, voluntarily or unintentionally, sounds forming a benthic biophony. Clacal prawns produce sounds by closing their claws so quickly that cavitation bubbles are created and produce &ldquo;mini-explosions&rdquo; (see Figure 2 )These claquements are strong and regular enough to create ambient noise from coastal environments (Johnson et al, 1947; Au and Bank, 1998; Versluis et al, 2000; Chitre et al, 2012).</p>
			<p>However, benthic biophony is not limited to the contribution of claqueus shrimp, sea urchins create sounds during their movement and nutrition. Their Aristotle lantern produces a crackle that is amplified by the spherical skeleton of the sea urchin (Radford et al, 2008). Decapods create sounds during their movement, nutrition, acoustic communication is even suspected in some species (Popper et al, 2001, Coquereau et al, 2016-a, J&eacute;z&eacute;quel et al, 2018). Closing and opening the valves of marine bivalves produces sound (Di Iorio et al, 2012). The individual sounds of these benthic stands mix to form a benthic biophony (Coquereau et al, 2016-b).</p>
			<p>The sounds emitted by the benthic invertebrates are derived from the clacking of pliers, shocks and movements of the hard parts of the calcareous skeleton of the invertebrates. Depending on the proximity of the transmitting animal and the strength of the signal emitted, they detach from the ambient noise and we can individualize them. In this case, they take the form of a &ldquo;transient&rdquo; or &ldquo;impulsive&rdquo; envelope concentrating its energy over a very short period of time and modulating a carrier whose frequency corresponds to the frequency of natural vibration of the limestone pieces colliding or air bubbles created in the water (Clay and Medwin, 1977).</p>
		</>,
		plusLoin: <>
			<p>Gervaise, C., Lossent, J., Valentini-Poirier, C. A., Boissery, P., Noel, C., & Di Iorio, L. (2019). Three-dimensional mapping of the benthic invertebrates biophony with a compact four-hydrophones array. Applied Acoustics, 148, 175-193.</p>
			<p>Coquereau, L., Grall, J., Chauvaud, L., Gervaise, C., Clavier, J., Jolivet, A., & Di Iorio, L. (2016). Sound production and associated behaviours of benthic invertebrates from a coastal habitat in the north-east Atlantic. Marine biology, 163(5), 1-13.</p>
		</>,
		son: "01_Invertebres_sous_marins.mp3",
	},
	{
		id: 4,
		name: "Fin whale",
		x: 44,
		y: 38,
		img: imgRorqual,
		texte: <>
			<p>Regular emissions at 20Hz probably used to interact socially. Here the sound is accelerated 5 times to be audible to the human ear. Detection range estimated at several tens of kilometers and a noise chorus observable up to hundreds of kilometers.</p>
			<p>Sound-emitting marine mammals fall into two broad categories: mysticetes (baleen whales) and odontocetes (toothed whales). Fin whales are part of the mystics. The fin whale is found mostly in the open sea.</p>
		</>,
		son: "rorqual.wav",
	},
	{
		id: 5,
		name: "Fishes",
		x: 49,
		y: 23,
		img: imgPoissons,
		portee: 300,
		texte: <>
			<p>Fish voluntarily emit sounds for communication purposes mainly during reproduction (location and selection of males, bridal parades synchronization of gamete emission), reporting of presence, warning and defense of territory. Having to carry information, the form of the signals is elaborated and it allows detection and classification. However, the range of sounds remains limited because they are adapted to the distances of interaction between fish ranging from a few meters to a few hundred meters. Fish also produce unintentional sounds when they feed.</p>
			<p>Of the 32,000 fish species, at least 700 have been identified as sound producers. Fish produce communication sounds through 4 different mechanisms:</p>
			<ul>
					<li>Vibrating their swim bladders with fast muscles specially designed for sound emissions that set in motion bone hammers hitting the swim bladder;</li>
					<li>By vibrating tendons or other internal organs with muscles specially designed for sound emissions; by releasing gas contained in the swim bladder;</li>
					<li>Stridulation by vibrating their teeth, two bones on each other or the needles of the fins.</li>
			</ul>
			<p>Sound production by swimming bladder vibration and tendon stridulation are the most frequent and produce the highest sound levels.</p>
			<p>Except in special cases, the sound production of fish follows a common pattern: an exciter (muscle) comes to vibrate a resonator (swim bladder, tendon, bone) and this several times consecutively. The sounds emitted appear thus constituted of an envelope gathering several pulses modulated by a cosine. The number of pulses and their rate of repetition depend on the excitatory muscle&rsquo;s ability to activate. The resonant frequency depends on the size of the resonator (tendon, bladder). Sounds sound like a drum for the slowest beats and like &ldquo;frog signals&rdquo; for the fastest beats.</p>
		</>,
		plusLoin: <>
			<p>AMORIM, M. Clara P. Diversity of sound production in fish. Communication in fishes, 2006, vol. 1, p. 71-104.</p>
		</>,
		son: "07_famiille09_poisson_5s.wav",
	},
	{
		id: 6,
		name: "Sperm whale",
		x: 55,
		y: 43,
		img: imgCachalot,
		texte: <>
			<p>Regular emissions at 20Hz probably used to interact socially. Here the sound is accelerated 5 times to be audible to the human ear. Detection range estimated at several tens of kilometers and a noise chorus observable up to hundreds of kilometers.</p>
			<p>Sound-emitting marine mammals fall into two broad categories: mysticetes (baleen whales) and odontocetes (toothed whales). Sperm whales are part of odontoceletes. Many sperm whales enjoy suitable habitat on the headlands between the continental shelf and the full ocean.</p>
		</>,
		son: "cachalot.wav",
	},
	{
		id: 7,
		name: "Poisson des Herbiers",
		x: 60,
		y: 29,
		img: imgPoissonHerbiers,
		portee: "300 to 1200",
		texte: <>
			<p>Individual sound range 300 m, chorus range 1200 m</p>
			<p>Emission in the framework in summer at night, by the rascasses, indicators of the state of health of the herbaria.</p>
		</>,
		plusLoin: <>
			<p>Di Iorio, L., Raick, X., Parmentier, E., Boissery, P., Valentini‐Poirier, C. A., & Gervaise, C. (2018). ‘Posidonia meadows calling’: a ubiquitous fish sound with monitoring potential. Remote Sensing in Ecology and Conservation, 4(3), 248-263.</p>
			<p>Bolgan, M., Soulard, J., Di Iorio, L., Gervaise, C., Lejeune, P., Gobert, S., & Parmentier, E. (2019). Sea chordophones make the mysterious/Kwa/sound: identification of the emitter of the dominant fish sound in Mediterranean seagrass meadows. Journal of Experimental Biology, 222(11), jeb196931.</p>
		</>,
		son: "08_herbier_prado_60s.wav",
	},
	{
		id: 8,
		name: "Brown meagre",
		x: 78,
		y: 34,
		img: imgCorb,
		portee: 300,
		texte: <>
			<p>Emission as part of reproduction in summer at night.</p>
		</>,
		plusLoin: <>
			<p>Parmentier, E., Di Iorio, L., Picciulin, M., Malavasi, S., Lagardère, J. P., & Bertucci, F. (2018). Consistency of spatiotemporal sound features supports the use of passive acoustics for long‐term monitoring. Animal Conservation, 21(3), 211-220.</p>
			<p>Di Iorio, L., Bonhomme, P., Michez, N., Ferrari, B., Gigou, A., Panzalis, P., … & Gervaise, C. (2020). Spatio-temporal surveys of the brown meagre Sciaena umbra using passive acoustics for management and conservation. BioRxiv.</p>
		</>,
		son: "02_Corb.wav",
	},
	{
		id: 9,
		name: "Bottlenose dolphin",
		x: 90,
		y: 41,
		img: imgDauphin,
		portee: 1000,
		texte: <>
			<p>2 components: whistles for communication, sonar clicks for geolocation and hunting.</p>
			<p>The sound emissions of bottlenose dolphins are divided into two families (Au, 1993): signals dedicated to social interactions and signals dedicated to the geolocation of obstacles or prey.</p>
			<p>Signals dedicated to social interactions are commonly referred to as &ldquo;whistling&rdquo; or &ldquo;vocalizations&rdquo; and are in the form of low-directional frequency modulated signals (May-Collado and Wartzok, 2008). The frequencies emitted are between 3 kHz and 15 kHz, with a duration of about 0.5 seconds. The law of instantaneous frequency presents stairways characteristic of the great dolphins with regard to the other species of dolphins . It allows the recognition of the species or even individuals (Bazua-Duran, 2004; Janik et al, 2006). The sound level of whistles is 158+-1 dB re.1&micro;Pa@1m corresponding to a communication space between individuals between 1 km and 4 km (Janik, 1999).</p>
			<p>Signals dedicated to the geolocation of obstacles or prey are commonly referred to as echolocation clicks. They are organized into a series of very short (8-72 &micro;s, Wahlberg et al, 2011) directional (7&deg; emission cone, Au, 1993) signals called pulses or clicks (Au, 1993). The succession is called the &ldquo;clicktrain&rdquo;. Within the same train the emission dates are not randomly distributed but are organized either with a constant interval between clicks (HERE: Inter Click Interval, HERE between 0.0005 s and 0.1s) this interval depends on the distance of search for prey or obstacles or either with an accelerating interval between clicks when the dolphin approaches an obstacle or prey. At the maximum repetition rate of clicks, the click train are called buzz and often characterizes the preceding moments an attempt to capture prey. The peak frequency of clicks varies according to the angle of capture in relation to the emission angle, it is between 30 kHz and 60 kHz for &apos;off-axis&apos; clicks (measured outside the emission cone) and can reach 120 kHz for &apos;on-axis&apos; clicks. (measured in the emission cone). Their bandwidth varies between 23 and 54 kHz (Wahlberg et al, 2011). The emitted sound levels are 177+-7 dB re.1&micro;Pa peak-peak @1m for off-axis clicks and can rise to 228 dB re. 1&micro;Pa peak-peak @1m for on-axis clicks (Wahlberg et al, 2011).</p>
		</>,
		plusLoin: <>
			<p>Au, W. W. (1993). The sonar of dolphins. Springer Science & Business Media.</p>
			<p>Jones, B., Zapetis, M., Samuelson, M. M., & Ridgway, S. (2020). Sounds produced by bottlenose dolphins (Tursiops): A review of the defining characteristics and acoustic criteria of the dolphin vocal repertoire. Bioacoustics, 29(4), 399-440.</p>
		</>,
		son: 'dauphins.wav',// TMP
	},
	
]